import React from 'react';

export type ReportingIconProps = {
  className?: string,
};

const DEFAULT_CLASS = 'h-5 w-5';

export const BarChart2Icon = ({ className = DEFAULT_CLASS }: ReportingIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' className={className} fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M18 20V10M12 20V4M6 20v-6' />
  </svg>
);

export const FilterIcon = ({ className = DEFAULT_CLASS }: ReportingIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' className={className} fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M22 3H2l8 9.46V19l4 2v-8.54L22 3z' />
  </svg>
);

export const BriefcaseIcon = ({ className = DEFAULT_CLASS }: ReportingIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' className={className} fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <rect x={2} y={7} width={20} height={14} rx={2} ry={2} strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16' />
  </svg>
);

export const UsersIcon = ({ className = DEFAULT_CLASS }: ReportingIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' className={className} fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
    <circle cx={9} cy={7} r={4} strokeWidth={2} />
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M22 21v-2a4 4 0 0 0-3-3.87' />
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M16 3.13a4 4 0 0 1 0 7.75' />
  </svg>
);

export const ClipboardCheckIcon = ({ className = DEFAULT_CLASS }: ReportingIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' className={className} fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <rect x={8} y={2} width={8} height={4} rx={1} ry={1} strokeWidth={2} />
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' />
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='m9 14 2 2 4-4' />
  </svg>
);

export const TrendingUpIcon = ({ className = DEFAULT_CLASS }: ReportingIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' className={className} fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <polyline points='22 7 13.5 15.5 8.5 10.5 2 17' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
    <polyline points='16 7 22 7 22 13' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
  </svg>
);

export const DownloadIcon = ({ className = DEFAULT_CLASS }: ReportingIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' className={className} fill='none' viewBox='0 0 24 24' stroke='currentColor'>
    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
    <polyline points='7 10 12 15 17 10' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
    <line x1={12} x2={12} y1={15} y2={3} strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
  </svg>
);
